<template>
  <div class="report-sidebar">
    <div class="report-sidebar_wrap">
      <slot></slot>

      <div
        class="report-sidebar__item"
        v-for="(item, index) in menus"
        :key="index"
        :class="{ actived: index === actived, disabled: loading }"
        @click="change(index)"
      >
        <div class="sidebar-item__title" :style="item.color ? `color: ${item.color}` : ''">
          <div class="sidebar-item__check"></div>
          {{ item.name }}
        </div>

        <div class="sidebar-item__content">
          合计识别: {{ item.count }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    actived: Number,
    loading: Boolean,
    menus: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      colors: [
        '#FF6384',
        '#36A2EB',
        '#FFCE56',
        '#41B883',
        '#cc65fe',
        '#bda29a',
        '#f28f43',
        '#a6c96a',
        '#546570',
        '#77a1e5'
      ]
    }
  },
  methods: {
    change(index) {
      if (!this.loading) {
        this.$emit('change', index)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$borderColor: #dcdfe6;
$active-color: #009688;
$--color-primary: #009688;

.report-sidebar {
  overflow-x: hidden;
  overflow-y: auto;
  width: 180px;
  flex: 0 0 180px;
  border-right: 1px solid #dcdfe6;
  height: 100%;
  text-align: center;
  .report-sidebar__item {
    // display: flex;
    // flex-direction: column;
    // justify-content: center;
    // align-items: center;
    border: 1px solid transparent;
    border-bottom: 1px solid $borderColor;
    cursor: pointer;
    text-align: left;
    padding: 12px;
    &:hover,
    &.actived {
      border: 1px solid $--color-primary;
    }
  }
  .report-sidebar_wrap {
  }
  .report-sidebar__item:hover {
    color: #409eff;
  }
  .actived {
    color: #409eff;
    .sidebar-item__check {
      background-color: $--color-primary;
    }
  }
  .sidebar-item__title {
    font-size: 14px;
    user-select: none;
    padding-bottom: 8px;
    border-bottom: 1px solid #f1f1f1;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .sidebar-item__content {
    font-size: 14px;
    user-select: none;
    padding-top: 12px;
    color: #909399;
  }
  .sidebar-item__subtitle {
    font-size: 12px;
    user-select: none;
  }
  .disabled {
    // pointer-events: none;
    cursor: wait !important;
  }
  .sidebar-item__check {
    width: 12px;
    height: 12px;
    border: 1px solid $--color-primary;
    margin-right: 4px;
  }
}
</style>
